/// <amd-module name="Artifacts/Root/redux/Sagas" />

import { isUserAnonymousOrPublic } from "Artifacts/Root/helpers/UserHelpers";
import {
  ILoadFeedMessagesPayload,
  IResolveFeedPayload,
  RootActions,
  RootActionTypes,
} from "Artifacts/Root/redux/Actions";
import { call, getContext, put, takeEvery } from "Artifacts/Root/Saga";
import { FeedMessageService } from "Artifacts/Root/services/FeedMessageService";
import { IFeedResolvingService } from "Artifacts/Root/services/FeedResolvingService";
import { FeedMessage } from "Artifacts/Root/types/AzureArtifacts";
import { SagaIterator } from "redux-saga";
import { ActionWithPayload } from "redux/Utils/ActionHelper";
import { IVssPageContext } from "VSS/Platform/Context";

export default function* rootSaga(): SagaIterator {
  yield takeEvery(RootActionTypes.LoadFeedMessages, loadFeedMessages);
  yield takeEvery(RootActionTypes.ResolveFeed, storeMruFeed);
}

function* loadFeedMessages(
  action: ActionWithPayload<RootActionTypes.LoadFeedMessages, ILoadFeedMessagesPayload>,
): SagaIterator {
  try {
    const { feed } = action.payload;
    const pageContext: IVssPageContext = (yield getContext("pageContext")) as any;
    const feedMessageService: FeedMessageService = pageContext.getService("IFeedMessageService");
    const feedMessages: FeedMessage[] = (yield call(
      [feedMessageService, feedMessageService.getFeedMessages],
      pageContext,
      feed,
    )) as any;

    if (feedMessages) {
      yield put(RootActions.showFeedMessages(feedMessages));
    }
  } catch (error) {
    // feed message isn't super important, so if things fail, keep going
    return;
  }
}

function* storeMruFeed(
  action: ActionWithPayload<RootActionTypes.ResolveFeed, IResolveFeedPayload>,
): SagaIterator {
  const { feed } = action.payload;
  const pageContext: IVssPageContext = (yield getContext("pageContext")) as any;

  if (!isUserAnonymousOrPublic(pageContext)) {
    // Set mru as feedId@viewId if view exists
    const feedResolvingService = pageContext.getService<IFeedResolvingService>(
      "IFeedResolvingService",
    );
    const fullyQualifiedFeedId = feed.selectedViewId
      ? feed.id + "@" + feed.selectedViewId
      : feed.id;
    (yield call(
      [feedResolvingService, feedResolvingService.setMruFullyQualifiedFeedId],
      fullyQualifiedFeedId,
    )) as any;
  }
}
